export function encodeMessage(message) {
  const newMessage = message.replace(/\r\n/g, '\n');
  let encoded = '';

  for (let i = 0; i < newMessage.length; ++i) {
    const chr = newMessage.charCodeAt(i);
    encoded += '&#' + chr + ';';
  }
  return encoded;
}
